var _ = require('lodash');
var Backbone = require('backbone');
var $ = require('jquery');
Backbone.$ = $;

require('bootstrap-modal');
require('bootstrap-button');
require('./util/mixin');
require('../styles/main.scss');

var DocumentWidget = require('./DocumentWidget');
var WidgetClassName = 'telescopedocumentwidget';

module.exports = function(options) {
    var options = options || {};

    options.container = $(options.container || document.body);
    options.modal = $(options.modal || options.container);

    options.uniqueId =
        options.uniqueId ||
        $(options.container).attr('id') ||
        (function() {
            var retval = WidgetClassName;
            if (options.widget_id) {
                retval += '-' + options.widget_id + '-';
            }
            retval += Date.now() % 1e6;
            return retval;
        })();

    if (!$(options.uniqueId).length) {
        $(options.container).attr('id', options.uniqueId);
    }

    DocumentWidget(options);
};